import { Component } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import TutorialMixin from '@/components/tutorial/tutorial-mixin';

@Component
export default class CampaignTutorialMixin extends mixins(TutorialMixin) {
  get introStepsDefault() {
    return {
      2: `<div class='introjs-tooltip__title'>${this.t('Campaign Settings')}</div><div class='introjs-tooltip__content'>${this.t('Specify name of campaign')}</div>`,
      3: `<div class='introjs-tooltip__title'>${this.t('Campaign Settings')}</div><div class='introjs-tooltip__content'>${this.t('Select a traffic source')}</div>`,
      4: `<div class='introjs-tooltip__title'>${this.t('Campaign Settings')}</div><div class='introjs-tooltip__content'>${this.t('Select URL as campaign destination')}</div>`,
      5: `<div class='introjs-tooltip__title'>${this.t('Campaign Settings')}</div><div class='introjs-tooltip__content'>${this.t('Specify the URL which will be the endpoint of your traffic')}</div>`,
      6: `<div class='introjs-tooltip__title'>${this.t('Campaign Settings')}</div><div class='introjs-tooltip__content'>${this.t('Create campaign')}</div>`,
    };
  }

  get quickStartSection() {
    return 'campaigns';
  }
}